import React from 'react';
import { Label } from '@patternfly/react-core';
import type { AntispamPlatform } from '../../../types/models/AntispamPlatform';

interface AntispamStatusLabelProps {
  platformId: number | null;
  platforms: AntispamPlatform[];
}

export const AntispamStatusLabel = ({ platformId, platforms }: AntispamStatusLabelProps) => {
  if (platformId === null) {
    return (
      <Label color="grey" isCompact>
        Off
      </Label>
    );
  }
  const name = platforms.find((p) => p.id === platformId)?.name;
  return (
    <Label color="green" isCompact>
      {name ? `On — ${name}` : 'On'}
    </Label>
  );
};
